/**
 * The Pro trial's line on a closed feature (#2816, «Показ пробы»): before the
 * trial starts — «14 days of Pro features start with your next analysis»;
 * after it ends — «The trial ended on {date}». One component for the lock
 * screen (`TierLockedScreen`) and the strip over demo data (`LockedDemoBanner`).
 *
 * Nothing for a feature the trial does not open (sold from Business up — the
 * promise would be false) and nothing while the trial runs: then the feature is
 * open and its lock is not on screen.
 */
import { useTranslation } from 'react-i18next';
import { PRO_TRIAL_DAYS } from '@aica/core';
import { useProTrial, type FeatureFlags } from '@/contexts/FeatureFlagsContext';
import { trialOpensFeature } from '@/lib/pro-trial';
import { cn, formatDateLocale } from '@/lib/utils';

export function ProTrialLockNote({
  flag,
  className,
}: {
  flag: keyof FeatureFlags;
  className?: string;
}) {
  const { t } = useTranslation('common');
  const proTrial = useProTrial();
  if (!proTrial || proTrial.state === 'active' || !trialOpensFeature(flag)) return null;

  const text =
    proTrial.state === 'available'
      ? t('featureGate.trial.available', { count: PRO_TRIAL_DAYS })
      : proTrial.endsAt
        ? t('featureGate.trial.ended', { date: formatDateLocale(proTrial.endsAt) })
        : t('featureGate.trial.endedUndated');

  return (
    <p
      data-testid={`pro-trial-lock-note-${proTrial.state}`}
      className={cn('text-sm', className)}
    >
      {text}
    </p>
  );
}
